import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useCallback, useMemo, useRef, useState } from 'react';
import * as React from 'react';
import * as turf from '@turf/turf';
import { Marker, GeolocateControl, Source, Layer } from 'react-map-gl';
import { useTranslation } from 'next-i18next';
import { getAssetSrc } from '@restworld/utils-common';
import CurrentLocationPinControlButton from './location-pin-control-button';
import { MapWrapper } from '../../design-system';
import { Button } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var radius = 0.5;
export var MapComponent = function MapComponent(_ref) {
  var _circle$geometry;

  var lon = _ref.lon,
      lat = _ref.lat,
      approximateLat = _ref.approximateLat,
      approximateLon = _ref.approximateLon,
      showRestaurant = _ref.showRestaurant;
  var mapRef = useRef(null);

  var _useState = useState(false),
      toggleMapView = _useState[0],
      _mapViewToggler = _useState[1];

  var coordinates = useMemo(function () {
    return showRestaurant ? [lon, lat] : [approximateLon, approximateLat];
  }, [approximateLat, approximateLon, lat, lon, showRestaurant]);
  coordinates = coordinates.length ? _toConsumableArray(coordinates).map(function (v) {
    return v ? Number(v) : 0;
  }) : [];
  var options = {
    steps: 100,
    units: 'kilometers'
  };
  var circle = turf.circle(coordinates, radius, options);
  var cor = (_circle$geometry = circle.geometry) === null || _circle$geometry === void 0 ? void 0 : _circle$geometry.coordinates[0];
  var line = turf.lineString(cor);

  var _React$useState = React.useState(13),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      zoomLevel = _React$useState2[0],
      setZoomLevel = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showCurrentLocationPinCtlButton = _React$useState4[0],
      setShowCurrentLocationPinCtlButton = _React$useState4[1];

  React.useEffect(function () {
    if (zoomLevel < 13) {
      setShowCurrentLocationPinCtlButton(true);
    } else {
      setShowCurrentLocationPinCtlButton(false);
    }
  }, [zoomLevel]);
  var handleZoomEnd = useCallback(function (e) {
    setZoomLevel(e.viewState.zoom);
  }, []);
  var handleClickCurrentLocationPinCtlButton = useCallback(function () {
    var _mapRef$current;

    (_mapRef$current = mapRef.current) === null || _mapRef$current === void 0 ? void 0 : _mapRef$current.flyTo({
      center: [coordinates[0], coordinates[1]],
      duration: 2000,
      zoom: 13
    });
  }, [coordinates]);
  var radiusEl = useMemo(function () {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Source, {
        id: "my-data",
        type: "geojson",
        data: circle,
        children: /*#__PURE__*/_jsx(Layer, {
          id: "point-90-hi",
          type: "fill",
          paint: {
            'fill-color': "#693eb5",
            'fill-opacity': 0.08
          }
        })
      }), /*#__PURE__*/_jsx(Source, {
        id: "approx-circle",
        type: "geojson",
        data: line,
        children: /*#__PURE__*/_jsx(Layer, {
          id: "point-9-hi",
          type: "line",
          paint: {
            'line-color': "#693eb5",
            'line-width': 1
          }
        })
      })]
    });
  }, [circle, line]);
  var marker = useMemo(function () {
    return /*#__PURE__*/_jsx(Marker, {
      longitude: coordinates[0],
      latitude: coordinates[1],
      children: /*#__PURE__*/_jsx("img", {
        src: getAssetSrc('/utils-assets/location-marker.svg'),
        alt: ""
      })
    });
  }, [coordinates]);
  return /*#__PURE__*/_jsx(Wrapper, {
    children: toggleMapView ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [showCurrentLocationPinCtlButton ? /*#__PURE__*/_jsx(CurrentLocationPinControlButton, {
        onClick: handleClickCurrentLocationPinCtlButton
      }) : /*#__PURE__*/_jsx(_StyledDiv, {}), /*#__PURE__*/_jsxs(MapWrapper, {
        coordinates: coordinates,
        mapRef: mapRef,
        handleZoomEnd: handleZoomEnd,
        children: [showRestaurant || zoomLevel <= 9 ? marker : zoomLevel >= 11.5 ? radiusEl : /*#__PURE__*/_jsxs(_Fragment, {
          children: [marker, radiusEl]
        }), /*#__PURE__*/_jsx(GeolocateControl, {
          positionOptions: {
            enableHighAccuracy: true
          },
          trackUserLocation: true
        })]
      })]
    }) : /*#__PURE__*/_jsx(ImageLoadPlaceholder, {
      mapViewToggler: function mapViewToggler() {
        _mapViewToggler(true);

        setTimeout(function () {
          handleClickCurrentLocationPinCtlButton();
        }, 500);
      }
    })
  });
};
export default MapComponent;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-location-map__Wrapper",
  componentId: "sc-2j9roy-0"
})(["", " .mapboxgl-map{", "}"], {
  "position": "relative",
  "marginBottom": "36px",
  "height": "24rem",
  "width": "100%"
}, {
  "borderRadius": "0.25rem"
});

export var ImageLoadPlaceholder = function ImageLoadPlaceholder(_ref2) {
  var mapViewToggler = _ref2.mapViewToggler;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(_StyledDiv2, {
    children: /*#__PURE__*/_jsxs(_StyledDiv3, {
      children: [/*#__PURE__*/_jsx(_StyledImg, {
        src: getAssetSrc('/utils-assets/map-placeholder-image.png'),
        alt: ""
      }), /*#__PURE__*/_jsx(_StyledSpan, {
        children: /*#__PURE__*/_jsx(Button, {
          title: t('view_location_on_map'),
          variant: "secondary-outline",
          onClick: mapViewToggler
        })
      })]
    })
  });
};
export * from './job-location-map.mocks';

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-location-map___StyledDiv",
  componentId: "sc-2j9roy-1"
})({
  "height": "29px"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-location-map___StyledDiv2",
  componentId: "sc-2j9roy-2"
})({
  "position": "absolute",
  "zIndex": "8",
  "height": "100%",
  "width": "100%"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "job-location-map___StyledDiv3",
  componentId: "sc-2j9roy-3"
})({
  "position": "relative",
  "display": "inline-block",
  "height": "100%",
  "width": "100%"
});

var _StyledImg = /*#__PURE__*/_styled("img").withConfig({
  displayName: "job-location-map___StyledImg",
  componentId: "sc-2j9roy-4"
})({
  "height": "100%",
  "width": "100%",
  "objectFit": "cover"
});

var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "job-location-map___StyledSpan",
  componentId: "sc-2j9roy-5"
})({
  "position": "absolute",
  "top": "50%",
  "left": "50%",
  "--tw-translate-x": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-translate-y": "-50%"
});